/* eslint-disable no-plusplus */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import axios from 'axios';
import Colors from '../Configs/colors';
import { clearStorage, getToken, getUserData } from './storages';

const baseUrl = process.env.REACT_APP_API_URL;
const token = getToken();
export const fetchClient = axios.create({ baseURL: baseUrl });

// Request interceptor for API calls
fetchClient.interceptors.request.use(
  async (config) => {
    const defaultConfig = config;
    defaultConfig.headers = {
      Authorization: `Bearer ${token}`,
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

// Response interceptor for API calls
fetchClient.interceptors.response.use((response) => response, async (error) => {
  const originalRequest = error.config;
  if (error.response.data.data === 'Not Authorized, access token is expired') {
    clearStorage();
    window.location.reload();
    return fetchClient(originalRequest);
  }
  return Promise.reject(error);
});

export const setClientToken = (tkn) => {
  // eslint-disable-next-line dot-notation
  fetchClient.defaults.headers.common['Authorization'] = `Bearer ${tkn}`;
};

export const renderIndicator = (onClickHandler, isSelected, index, label) => {
  const defStyle = {
    height: 10,
    width: 10,
    borderRadius: 5,
    marginLeft: 8,
    backgroundColor: '#FAFAFF',
    border: '1px solid #282828',
    display: 'inline-block',
  };
  const style = isSelected
    ? { ...defStyle, backgroundColor: Colors.black, border: '1px solid #fff' }
    : { ...defStyle };
  return (
    <span
      style={style}
      onClick={onClickHandler}
      onKeyDown={onClickHandler}
      value={index}
      key={index}
      role="button"
      tabIndex={0}
      aria-label={`${label} ${index + 1}`}
    />
  );
};

export const onlyNumbers = (data = '') => {
  const numberOnly = data.replace(/[^0-9]/g, '');
  return numberOnly;
};

export function formatNum(num = 0, separator = '.') {
  let str = num?.toLocaleString('en-US');
  str = str?.replace(/\./, ',');
  str = str?.replace(/,/g, separator);
  return str;
}

export function formatNumToCurrency(num = 0, separator = '.') {
  let str = num?.toLocaleString('en-US');
  str = str?.replace(/\./, ',');
  str = str?.replace(/,/g, separator);
  return `₣ ${str}.00`;
}

export const isB2B = () => {
  const user = getUserData() || {};
  if (user.subscription === 'Business to Business (B2B)') {
    return true;
  }
  return false;
};

export const isB2C = () => {
  const user = getUserData() || {};
  if (user.subscription === 'Business to Customer (B2C)') {
    return true;
  }
  return false;
};

export const isSubscriber = () => {
  const user = getUserData() || {};
  return Boolean(user.subscription);
};

// function to get description request mix type
export const getTotalItems = (req) => {
  let text = '';
  const itemLength = req.items?.length || 0;
  const boxLength = req.box?.length || 0;
  if (itemLength) {
    text += itemLength > 1 ? `${itemLength} items` : `${itemLength} item`;
  }

  if (boxLength) {
    if (itemLength) {
      text += ' & ';
    }
    text += boxLength > 1 ? `${boxLength} boxes` : `${boxLength} box`;
  }

  const result = `${itemLength + boxLength} (${text})`;
  return result;
};

export const calculateNeededStorage = (req) => {
  const boxLength = req.box?.length || 0;
  const itemLength = req.items?.length || 0;
  let boxToItems = 0;

  if (boxLength) {
    for (let index = 0; index < req.box.length; index++) {
      const element = req.box[index];
      if (element?.type === '1x3') boxToItems += 3;
      else if (element?.type === '2x6') boxToItems += 12;
      else boxToItems += 6;
    }
  }

  const neededStorageForItems = Math.ceil((itemLength + boxToItems) / 12);

  return neededStorageForItems;
};

export const formatVolumeToInt = (volume) => {
  if (volume) {
    const [number, unit] = volume.toLowerCase().split(' ');
    if (unit === 'l') return number * 1000;
    return number;
  }
  return 0;
};

export function separateArray(array, maxLength = 12) {
  const separatedArrays = [];
  let tempArray = [];

  for (let i = 0; i < array.length; i++) {
    tempArray.push(array[i]);

    // Check if tempArray reached maximum length or we are at the end of the original array
    if (tempArray.length === maxLength || i === array.length - 1) {
      separatedArrays.push([...tempArray]); // Push a copy of tempArray to the result array
      tempArray = []; // Reset tempArray
    }
  }

  return separatedArrays;
}

export function copyToClipboard(text = '') {
  window.navigator.clipboard.writeText(text);
}
